import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { ViIconButtonComponent } from '@vi-iot/ui/components/icon-button/icon-button.component';

@Component({
  selector: 'vi-notification',
  standalone: true,
  imports: [CommonModule, TranslateModule, ViIconButtonComponent, MatIconModule],
  templateUrl: 'notification.component.html',
  styleUrls: ['notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViNotificationComponent {
  @Input() type: string;
  @Input() icon: string;
  @Input() bold: boolean;
  @Input() shadow: boolean;
  @Input() layoutAlign: String = 'center';
  @Input() clickable: boolean;
  @Input() dismissible: boolean;
  @Output() closed: EventEmitter<void> = new EventEmitter<void>();

  onClose(): void {
    this.closed.emit();
  }
}
